/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum OnderbouwsnelheidUitzondering {
    REGULIERE_ONDERBOUWSNELHEID = "Reguliere onderbouwsnelheid",
    GEEN_ONDERBOUW = "Geen onderbouw",
    GEEN_1_OKTOBERPLAATSING = "Geen 1-oktoberplaatsing",
    TUSSENTIJDSE_INSTROOM = "Tussentijdse instroom",
    UITGESLOTEN_VAN_ROD_COMMUNICATIE = "Uitgesloten van ROD-communicatie",
    EMIGRATIE = "Emigratie",
    UITSTROOM_SPECIAAL_ONDERWIJS = "Uitstroom speciaal onderwijs",
    UITSTROOM_GEEN_VO = "Uitstroom/Geen VO",
    INTERNATIONALE_LEERLING = "Internationale leerling",
    PR_O_LEERLING = "PrO-leerling",
    VAVO_LEERLING = "VAVO leerling",
    NIEUWKOMER = "Nieuwkomer"
}
